var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225 225.5V152.25C225 116.25 217.25 88.75 175.25 88.75C155 88.75 141.5 99.75 136 110.25H135.5V92H95.75V225.5H137.25V159.25C137.25 141.75 140.5 125 162 125C183.25 125 183.5 144.75 183.5 160.25V225.25H225V225.5Z",
    fill: "#291953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 92H69.75V225.5H28.25V92Z",
    fill: "#291953"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25.5C35.75 25.5 25 36.25 25 49.5C25 62.75 35.75 73.75 49 73.75C62.25 73.75 73 62.75 73 49.5C73 36.25 62.25 25.5 49 25.5Z",
    fill: "#291953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5cbce0edb00cd81f9612de7c2c59be91.svg";
export { ForwardRef as ReactComponent };